import { LocaleText } from '../AppProvider';

import { getLocalization } from './getLocalization';

const enLabels: LocaleText = {
  ok: 'Ok',
  or: 'Or',

  to: 'To',
  // Common action labels
  save: 'Save',

  with: 'With',
  // Common authentication labels
  email: 'Email',
  close: 'Close',
  alert: 'Alert',

  cancel: 'Cancel',
  delete: 'Delete',
  editLabel: 'Edit',
  passkey: 'Passkey',

  confirm: 'Confirm',
  password: 'Password',
  username: 'Username',
  loading: 'Loading...',
  createLabel: 'Create',
  deleteLabel: 'Delete',
  deleteCancelLabel: 'Cancel',
  deleteConfirmLabel: 'Delete',
  // Account
  accountSignInLabel: 'Sign In',
  // AccountPreview
  accountPreviewTitle: 'Account',
  accountSignOutLabel: 'Sign Out',

  signInRememberMe: 'Remember Me',
  reloadButtonLabel: 'Reload data',
  // CRUD
  createNewButtonLabel: 'Create new',
  deleteConfirmTitle: 'Delete item?',
  accountPreviewIconButtonLabel: 'Current User',
  editSuccessMessage: 'Item edited successfully.',
  editErrorMessage: 'Failed to edit item. Reason:',
  deletedItemMessage: 'This item has been deleted.',
  createSuccessMessage: 'Item created successfully.',
  deleteSuccessMessage: 'Item deleted successfully.',
  createErrorMessage: 'Failed to create item. Reason:',
  deleteErrorMessage: 'Failed to delete item. Reason:',
  deleteConfirmMessage: 'Do you wish to delete this item?',
  signInSubtitle: 'Welcome user, please sign in to continue',
  providerSignInTitle: (provider: string) => `Sign in with ${provider}`,
  // SignInPage
  signInTitle: (brandingTitle?: string) =>
    brandingTitle ? `Sign in to ${brandingTitle}` : 'Sign in',
};

export default getLocalization(enLabels);
